let hidden, visibilityChange
if (document) {
	if (typeof document.hidden !== 'undefined') {
		hidden = 'hidden'
		visibilityChange = 'visibilitychange'
	} else if (typeof document.msHidden !== 'undefined') {
		hidden = 'msHidden'
		visibilityChange = 'msvisibilitychange'
	} else if (typeof document.webkitHidden !== 'undefined') {
		hidden = 'webkitHidden'
		visibilityChange = 'webkitvisibilitychange'
	}
}

const waitForReconnection = () => new Promise(resolve => {
	function handleChange() {
		if (!document[hidden]) {
			document.removeEventListener(visibilityChange, handleChange, false)
			resolve()
		}
	}
	document.addEventListener(visibilityChange, handleChange, false)
})

const isHidden = () => isSupported() && document[hidden]

const isSupported = () => !!hidden

const onChange = callback => {
	document.addEventListener(visibilityChange, callback, false)
}

export default {
	waitForReconnection,
	isHidden,
	isSupported,
	onChange,
}
